export const useSupabaseClient = () => useNuxtApp().$supabase;
